module.exports = __webpack_public_path__ + "img/3.a19a79d.png";